export default __webpack_public_path__ + "assets/images/50f853c468ba3323262265e5fc361e2c.png";